import { BrandLayout } from "__generated__/gql/graphql";

export const BRAND_LAYOUTS = [BrandLayout.DEFAULT, BrandLayout.ANALYTICS];

export const BRAND_LAYOUT_LABELS: Record<BrandLayout, string> = {
  [BrandLayout.DEFAULT]: "Default",
  [BrandLayout.ANALYTICS]: "Analytics",
};
